import { catchError } from 'rxjs/operators';
import { Observable, Subject, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InsightsServiceApi {

  error = new Subject<string>();

  constructor(private http: HttpClient) { }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }

  requestOptions: Object = {
    'Content-Type': 'application/json',
    observe: 'response',
  };

  getRegions() {
    let bLine = null;
    let pLine = null;
    let userId = sessionStorage.getItem('userId');
    return this.http.post<any>(
      `${environment.apiUrl}/v1/regions?userId=${userId}&businessLine=${bLine}&productLine=${pLine}`
      , {});
  }


  getProductLines(region: any) {
    let bLine = null;
    let userId = sessionStorage.getItem('userId');
    return this.http.post<any>(`${environment.apiUrl}/v1/productlines?userId=${userId}&businessLine=${bLine}&regionCode=${region}`, null);
  }

  getPairingRequest(region: any, productLine: string[]) {
    let userId = sessionStorage.getItem('userId');

    return this.http.post<any>(`${environment.apiUrl}/v1/fetchRequestList`, {
      userId: userId.toString(),
      regionCode: region,
      productLine: productLine
    });
  }

  onSubmit(formData: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http
      .post<any>(`${environment.apiUrl}/v1/submitVisualization`, formData, {
        headers: headers,
      })
      .pipe(catchError(this.errorHandler));
  }

  embadedDashboard() {
    let authId = sessionStorage.getItem('id');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;',
        'authId': authId
      }),
    };

    return this.http.post<any>(
      `${environment.apiUrl}/v1/embed-dashboard`, null, httpOptions);
  }


  refreshDashboard() {
    return this.http.post<any>(`${environment.apiUrl}/v1/embed-dashboard/refreshStatus`, {});
  }

  uploadReport(formData: any) {

    return this.http
      .post<any>(
        `${environment.apiUrl}/v1/upload/perimeterFile`,
        formData,
        this.requestOptions
      )
      .pipe(catchError(this.errorHandler));
  }


  getPriceFXFile() {
    const requestOptionsForDownload = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: sessionStorage.getItem('userId').toString(),
      }),
      responseType: 'blob' as 'json',
      observe: 'response' as const
    };
    return this.http.post<any>(
      `${environment.apiUrl}/v1/download/perimeter-file-template`,
      null,
      requestOptionsForDownload
    );
  }

   onSubmitSKU(formData: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http
      .post<any>(`${environment.apiUrl}/v1/submitSkuGenerator`, formData, {
        headers: headers,
      })
      .pipe(catchError(this.errorHandler));
  }

  onsubmitPriceFxLoader(formData: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http
      .post<any>(`${environment.apiUrl}/v1/submitPriceFxLoader`, formData, {
        headers: headers,
      })
      .pipe(catchError(this.errorHandler));
  }
}
